import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { LegalDocs } from '@srca-b2b/kp5-ui-common'
import Layout from 'components/Layout/Layout'
import { getLegalDocsServer, getLegalDocsVersion } from '@srca-b2b/kp5-ui-common/utils/legalAPIs'

const title = 'Samsung Care+ for Business Privacy Policy'
const legalType = 'privacy_policy_us_scpe'

const LegalAgreement = ({ legalDocsResponse, legalDocsVersions }) => {
  return (
    <Layout id={legalType} title={`${title} | Knox Partner Program`}>
      <Container>
        <Row>
          <Col sm={12}>
            <LegalDocs
              title={title}
              agreements={legalDocsResponse.data}
              legalVersions={legalDocsVersions.data[0].versions}
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export async function getServerSideProps() {
  let legalDocsResponse = await getLegalDocsServer([legalType])
  const legalDocsVersions = await getLegalDocsVersion(legalType)
  if (legalDocsResponse.statusCode !== 200) {
    return {
      redirect: {
        destination: '/en/404',
        permanent: false
      }
    }
  }
  return {
    props: { legalDocsResponse, legalDocsVersions }
  }
}

export default LegalAgreement
